<template>
  <AppButtonOk :disabled="currentStep <= 1" @click="onClickPrev">
    <v-icon large>mdi-menu-left</v-icon>
  </AppButtonOk>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SimulationFooterButtonPrev',
  computed: {
    ...mapGetters('simulation', ['currentStep', 'steps']),
  },
  methods: {
    ...mapActions('simulation', {
      prevStep: 'PREV_STEP',
    }),
    async onClickPrev() {
      await this.prevStep()
    },
  },
}
</script>

<style scoped></style>
